module.exports = __webpack_public_path__ + "static/media/4.9490ed24.jpeg";